/* API URL endpoints
 *
 * This information should match the API URLs defined in the Django backend application.
 */

export default {
  base: window.SITE_CONFIG.BASE_URL + '/api/v1/',
  videoUpload: `https://upload.dacast.com`,
  auth: {
    login: () => `auth/login/`,
    logout: () => `auth/logout/`,
    register: () => `auth/registration/`,
    social: (provider) => `auth/social/${provider}/`,
    resetPassword: () => `auth/password/reset/`,
    confirmResetPassword: () => `auth/password/reset/confirm/`,
    changePassword: () => `auth/password/change/`
  },
  profile: {
    me: () => `me/`,
    notifications: () => `notifications/`,
    avatar: () => `me/avatar/`,
    deactivate: () => `me/deactivate/`,
    hero: () => `me/hero/`,
    list: (id) => `profiles/`,
    detail: (id) => `profiles/${id}/`,
    follow: (id) => `profiles/${id}/follow/`,
    unfollow: (id) => `profiles/${id}/unfollow/`,
    following: () => `following/`,
    followers: () => `followers/`,
    block: (id) => `profiles/${id}/block/`,
    unblock: (id) => `profiles/${id}/unblock/`,
    report: (id) => `profiles/${id}/report/`,
    inboxes: () => `inboxes/`,
    conversations: (id) => `inboxes/${id}/conversations/`,
    messages: (inboxId, peerId) => `inboxes/${inboxId}/conversations/${peerId}/messages/`,
    markAsRead: (inboxId, peerId) => `inboxes/${inboxId}/conversations/${peerId}/mark_as_read/`
  },
  artist: {
    list: () => `artists/`,
    avatar: (id) => `artists/avatar/`,
    hero: (id) => `artists/hero/`,
    detail: (id) => `artists/${id}/`,
    donate: (id) => `artists/${id}/donate/`,
    report: (id) => `artists/${id}/report/`
  },
  tag: {
    list: () => `tags/`
  },
  song: {
    publish: {
      list: () => `publish/songs/`,
      detail: (id) => `publish/songs/${id}/`,
      thumbnail: (id) => `publish/songs/${id}/thumbnail/`,
      video: (id) => `publish/songs/${id}/video/`,
      audio: (id) => `publish/songs/${id}/audio/`
    },
    consume: {
      list: () => `songs/`,
      detail: (id) => `songs/${id}/`,
      purchase: (id) => `songs/${id}/purchase/`,
      listAccess: () => `access/`,
      rate: (id) => `songs/${id}/rate/`,
      touch: (id) => `songs/${id}/touch/`,
      report: (id) => `songs/${id}/report/`,
      commentList: (id) => `songs/${id}/comments/`,
      commentDetail: (songId, commentId) => `songs/${songId}/comments/${commentId}/`,
      reportComment: (songId, commentId) => `songs/${songId}/comments/${commentId}/report/`
    }
  },
  album: {
    list: () => `albums/`,
    detail: (id) => `albums/${id}/`,
    cover: (id) => `albums/${id}/cover/`,
    purchase: (id) => `albums/${id}/purchase/`
  },
  payment: {
    token: () => `payment/`,
    history: () => `payment/history/`,
    transactions: () => `artist/transactions/`,
    setupPayout: () => `artist/payout/`
  },
  live: {
    publish: {
      list: () => `publish/live/`,
      detail: (id) => `publish/live/${id}/`,
      promo: (id) => `publish/live/${id}/promo/`,
      start: (id) => `publish/live/${id}/start/`,
      stop: (id) => `publish/live/${id}/stop/`,
      block_user: (id) => `publish/live/${id}/block_user/`
    },
    consume: {
      list: () => `live/`,
      detail: (id) => `live/${id}/`,
      book: (id) => `live/${id}/book/`,
      watch: (id) => `live/${id}/watch/`,
      attend: (id) => `live/${id}/attend/`,
      ping: (id) => `live/${id}/ping/`,
      rate: (id) => `live/${id}/rate/`,
      report: (id) => `live/${id}/report/`,
      commentList: (id) => `live/${id}/comments/`,
      commentDetail: (eventId, commentId) => `live/${eventId}/comments/${commentId}/`,
      reportComment: (eventId, commentId) => `live/${eventId}/comments/${commentId}/report/`,
      messages: (id) => `live/${id}/messages/`,
      send_message: (id) => `live/${id}/send_message/`,
      delete_message: (id) => `live/${id}/delete_message/`
    },
    tickets: {
      list: () => `tickets/`
    }
  },
  feed: {
    combined: () => `feed/`,
    by: (id) => `profiles/${id}/feed/`,
    post: () => `publish/feed/`,
    delete: (id) => `publish/feed/${id}/`,
    reportUpdate: (id) => `feed/${id}/report/`,
    commentList: (id) => `feed/${id}/comments/`,
    commentDetail: (updateId, commentId) => `feed/${updateId}/comments/${commentId}/`,
    reportUpdateComment: (updateId, commentId) => `feed/${updateId}/comments/${commentId}/report/`
  },
  playlist: {
    list: () => `playlists/`,
    detail: (id) => `playlists/${id}/`,
    appendSong: (id) => `playlists/${id}/append/`,
    prependSong: (id) => `playlists/${id}/prepend/`,
    removeSong: (id) => `playlists/${id}/remove/`,
    follow: (id) => `playlists/${id}/follow/`,
    unfollow: (id) => `playlists/${id}/unfollow/`
  },
  search: {
    albums: () => `search/albums/`,
    artists: () => `search/artists/`,
    live: () => `search/live/`,
    playlists: () => `search/playlists/`,
    songs: () => `search/songs/`,
    recommended: () => `search/recommended/`
  }
}



// WEBPACK FOOTER //
// ./src/utils/urls.js